exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".risk-device-page .app-main{background-color:#fff;padding:5rem 0 0 0 !important}.risk-device-page .content iframe.template-portal{width:100%;height:100%;height:100vh}.risk-device-page .navbar{display:block !important}.risk-device-page .ng-hide{display:block !important}", ""]);

// exports
